const appg = {
  clear: () => {
    localStorage.clear();
  },
  setLoggedIn: (value) => {
    localStorage.setItem("loggedIn", JSON.stringify(value));
  },

  getLoggedIn: () => {
    return localStorage.getItem("loggedIn") === "true";
  },

  setApiKey: (value) => {
    localStorage.setItem("apiKey", value);
  },

  getApiKey: () => {
    return localStorage.getItem("apiKey");
  },

  setUserFullName: (value) => {
    localStorage.setItem("userFullName", value);
  },

  getUserFullName: () => {
    return localStorage.getItem("userFullName");
  },

  startWaiting: () => {
    appg.waiting = true;
  },

  stopWaiting: () => {
    appg.waiting = false;
  },
};

export default appg;
